export default "__VITE_ASSET__CtKhPjlX__"